import { createSelector } from 'reselect'

const getSelectedDatas = (state, layerName) => {
  return state.chart.data
}

const getLayerName = (state, layerName) => {
  return layerName
}

export const makeGetSelectedData = () => {
  return createSelector(
    [getSelectedDatas, getLayerName],
    (selectedDatas, layerName) => {
      if (selectedDatas && layerName && selectedDatas[layerName]) {
        return selectedDatas[layerName]
      } else {
        return null
      }
    }
  )
}



// WEBPACK FOOTER //
// ./src/selectors/selectedDataSelector.js